// extracted by css-extract-rspack-plugin
export default {"logo":"qIiB_","logo_short":"DeF8V","logoShort":"DeF8V","logo_full":"qtvNu","logoFull":"qtvNu","logo_default":"rFQWP","logoDefault":"rFQWP"};